<header class="sub-page-layout__header valueCode__header">
  <div class="valueCode__header-text h2 h2--semi-bold">Value Codes</div>
  <mat-slide-toggle
    class="valueCode__active-toggle"
    [checked]="activeFilter === 'active'"
    color="primary"
    (change)="showInactiveChanges($event)"
  >
    <div *ngIf="activeFilter !== 'inactive'">Active</div>
    <div *ngIf="activeFilter === 'inactive'">Inactive</div>
  </mat-slide-toggle>
  <button mat-flat-button color="primary" class="valueCode__add-item" (click)="uploadCodes()" *ngIf="!viewOnly">
    <mat-icon>file_upload</mat-icon> Upload Value Codes
  </button>
  <button mat-flat-button color="primary" class="valueCode__add-item" (click)="addValueCode()" *ngIf="!viewOnly">
    <mat-icon>add_circle_outline</mat-icon> Add Value Code
  </button>
</header>
<div *ngIf="dataSource && gridConfig" class="lib-grid__grid-container">
  <lib-grid [dataSource]="dataSource" [gridConfiguration]="gridConfig" skipLoadOnInit="true" loadAfterInit="true">
    <div class="">
      <h4>No Value Codes Found.</h4>
    </div>
  </lib-grid>
</div>
<footer *ngIf="isImplementation" class="valueCode__footer">
  <lib-button-loading color="primary" class="valueCode__button" (clickEvent)="next()" id="nextButton"
    >Next
  </lib-button-loading>
</footer>
